export default __webpack_public_path__ + "5e40a6e5e126f8dfbc37357644120621.png";